/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ForecastAPI {

  /**
   * Method that returns a dooh forecast from criterias
   * @param campaignId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiForecastDooh(
    campaignId?: number,
  ): CancelablePromise<{
    total_screens: number;
    total_impressions: number;
    total_spend: number;
    screens?: Array<{
      centroid_longitude: number;
      centroid_latitude: number;
      screen_ids?: Array<string>;
      screen_impressions?: Array<number>;
      screen_spends?: Array<number>;
      single_screen_data?: {
        screen_id?: string;
        screen_name?: string;
        publisher_id?: string;
        publisher_url?: string;
        country_id?: string;
        state_id?: string;
        city?: string;
        postal_code?: string;
        screen_address?: Array<string>;
        centroid_longitude?: number;
        centroid_latitude?: number;
        time_zone?: Array<string>;
        utcoffset?: number;
        impressions?: number;
        spend?: number;
        average_monthly_impressions?: number;
        average_monthly_spend?: number;
        ssp_id?: number;
        venue_type_ids?: Array<number>;
        screen_size?: number;
        audience_factor?: number;
        format?: Array<number>;
        allow_image?: boolean;
        allow_video?: boolean;
        last_update?: number;
      };
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    data?: Array<{
      date: string;
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/forecast/dooh',
      query: {
        'campaign_id': campaignId,
      },
    });
  }

  /**
   * Method that returns a dooh forecast from criterias with bounding box (west, south, east, north)
   * @param maxScreenId maximum returned screen id in a group
   * @param screenStats include stats with screen ids
   * @param resolution resolution of lat/lon grouping in meters
   * @param singleScreenData
   * @param west
   * @param south
   * @param east
   * @param north
   * @param campaignId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiForecastDoohMap(
    maxScreenId: number = 1,
    screenStats: boolean = false,
    resolution: number = 10000,
    singleScreenData: boolean = false,
    west?: number,
    south?: number,
    east?: number,
    north?: number,
    campaignId?: number,
  ): CancelablePromise<{
    total_screens: number;
    total_impressions: number;
    total_spend: number;
    screens?: Array<{
      centroid_longitude: number;
      centroid_latitude: number;
      screen_ids?: Array<string>;
      screen_impressions?: Array<number>;
      screen_spends?: Array<number>;
      single_screen_data?: {
        screen_id?: string;
        screen_name?: string;
        publisher_id?: string;
        publisher_url?: string;
        country_id?: string;
        state_id?: string;
        city?: string;
        postal_code?: string;
        screen_address?: Array<string>;
        centroid_longitude?: number;
        centroid_latitude?: number;
        time_zone?: Array<string>;
        utcoffset?: number;
        impressions?: number;
        spend?: number;
        average_monthly_impressions?: number;
        average_monthly_spend?: number;
        ssp_id?: number;
        venue_type_ids?: Array<number>;
        screen_size?: number;
        audience_factor?: number;
        format?: Array<number>;
        allow_image?: boolean;
        allow_video?: boolean;
        last_update?: number;
      };
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    data?: Array<{
      date: string;
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/forecast/dooh/map',
      query: {
        'max_screen_id': maxScreenId,
        'screen_stats': screenStats,
        'resolution': resolution,
        'single_screen_data': singleScreenData,
        'west': west,
        'south': south,
        'east': east,
        'north': north,
        'campaign_id': campaignId,
      },
    });
  }

  /**
   * Method that returns a dooh forecast from criterias with a CPM distribution
   * @param campaignId
   * @param cpmDistributionBoundaries Ordered list of float values separated by commas
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiForecastDoohCpm(
    campaignId?: number,
    cpmDistributionBoundaries: string = '0,4,8,12',
  ): CancelablePromise<{
    total_screens: number;
    total_impressions: number;
    total_spend: number;
    screens?: Array<{
      centroid_longitude: number;
      centroid_latitude: number;
      screen_ids?: Array<string>;
      screen_impressions?: Array<number>;
      screen_spends?: Array<number>;
      single_screen_data?: {
        screen_id?: string;
        screen_name?: string;
        publisher_id?: string;
        publisher_url?: string;
        country_id?: string;
        state_id?: string;
        city?: string;
        postal_code?: string;
        screen_address?: Array<string>;
        centroid_longitude?: number;
        centroid_latitude?: number;
        time_zone?: Array<string>;
        utcoffset?: number;
        impressions?: number;
        spend?: number;
        average_monthly_impressions?: number;
        average_monthly_spend?: number;
        ssp_id?: number;
        venue_type_ids?: Array<number>;
        screen_size?: number;
        audience_factor?: number;
        format?: Array<number>;
        allow_image?: boolean;
        allow_video?: boolean;
        last_update?: number;
      };
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    data?: Array<{
      date: string;
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    groups?: Array<{
      screen_count: number;
      impressions: number;
      worth_cad: number;
      cpm_distribution_index?: number;
      venue_type_id?: number;
      ssp_id?: number;
      publisher_id?: string;
      format?: {
        width: number;
        height: number;
        id?: number;
      };
      format_id?: number;
      is_video?: boolean;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/forecast/dooh/cpm',
      query: {
        'campaign_id': campaignId,
        'cpm_distribution_boundaries': cpmDistributionBoundaries,
      },
    });
  }

  /**
   * Method that returns a dooh forecast from criterias with venue type context
   * @param campaignId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiForecastDoohVenueType(
    campaignId?: number,
  ): CancelablePromise<{
    total_screens: number;
    total_impressions: number;
    total_spend: number;
    screens?: Array<{
      centroid_longitude: number;
      centroid_latitude: number;
      screen_ids?: Array<string>;
      screen_impressions?: Array<number>;
      screen_spends?: Array<number>;
      single_screen_data?: {
        screen_id?: string;
        screen_name?: string;
        publisher_id?: string;
        publisher_url?: string;
        country_id?: string;
        state_id?: string;
        city?: string;
        postal_code?: string;
        screen_address?: Array<string>;
        centroid_longitude?: number;
        centroid_latitude?: number;
        time_zone?: Array<string>;
        utcoffset?: number;
        impressions?: number;
        spend?: number;
        average_monthly_impressions?: number;
        average_monthly_spend?: number;
        ssp_id?: number;
        venue_type_ids?: Array<number>;
        screen_size?: number;
        audience_factor?: number;
        format?: Array<number>;
        allow_image?: boolean;
        allow_video?: boolean;
        last_update?: number;
      };
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    data?: Array<{
      date: string;
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    groups?: Array<{
      screen_count: number;
      impressions: number;
      worth_cad: number;
      cpm_distribution_index?: number;
      venue_type_id?: number;
      ssp_id?: number;
      publisher_id?: string;
      format?: {
        width: number;
        height: number;
        id?: number;
      };
      format_id?: number;
      is_video?: boolean;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/forecast/dooh/venue_type',
      query: {
        'campaign_id': campaignId,
      },
    });
  }

  /**
   * Method that returns a dooh forecast from criterias with ssp context
   * @param campaignId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiForecastDoohSsp(
    campaignId?: number,
  ): CancelablePromise<{
    total_screens: number;
    total_impressions: number;
    total_spend: number;
    screens?: Array<{
      centroid_longitude: number;
      centroid_latitude: number;
      screen_ids?: Array<string>;
      screen_impressions?: Array<number>;
      screen_spends?: Array<number>;
      single_screen_data?: {
        screen_id?: string;
        screen_name?: string;
        publisher_id?: string;
        publisher_url?: string;
        country_id?: string;
        state_id?: string;
        city?: string;
        postal_code?: string;
        screen_address?: Array<string>;
        centroid_longitude?: number;
        centroid_latitude?: number;
        time_zone?: Array<string>;
        utcoffset?: number;
        impressions?: number;
        spend?: number;
        average_monthly_impressions?: number;
        average_monthly_spend?: number;
        ssp_id?: number;
        venue_type_ids?: Array<number>;
        screen_size?: number;
        audience_factor?: number;
        format?: Array<number>;
        allow_image?: boolean;
        allow_video?: boolean;
        last_update?: number;
      };
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    data?: Array<{
      date: string;
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    groups?: Array<{
      screen_count: number;
      impressions: number;
      worth_cad: number;
      cpm_distribution_index?: number;
      venue_type_id?: number;
      ssp_id?: number;
      publisher_id?: string;
      format?: {
        width: number;
        height: number;
        id?: number;
      };
      format_id?: number;
      is_video?: boolean;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/forecast/dooh/ssp',
      query: {
        'campaign_id': campaignId,
      },
    });
  }

  /**
   * Method that returns a dooh forecast from criterias with publisher & ssp context
   * @param campaignId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiForecastDoohPublisherSsp(
    campaignId?: number,
  ): CancelablePromise<{
    total_screens: number;
    total_impressions: number;
    total_spend: number;
    screens?: Array<{
      centroid_longitude: number;
      centroid_latitude: number;
      screen_ids?: Array<string>;
      screen_impressions?: Array<number>;
      screen_spends?: Array<number>;
      single_screen_data?: {
        screen_id?: string;
        screen_name?: string;
        publisher_id?: string;
        publisher_url?: string;
        country_id?: string;
        state_id?: string;
        city?: string;
        postal_code?: string;
        screen_address?: Array<string>;
        centroid_longitude?: number;
        centroid_latitude?: number;
        time_zone?: Array<string>;
        utcoffset?: number;
        impressions?: number;
        spend?: number;
        average_monthly_impressions?: number;
        average_monthly_spend?: number;
        ssp_id?: number;
        venue_type_ids?: Array<number>;
        screen_size?: number;
        audience_factor?: number;
        format?: Array<number>;
        allow_image?: boolean;
        allow_video?: boolean;
        last_update?: number;
      };
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    data?: Array<{
      date: string;
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    groups?: Array<{
      screen_count: number;
      impressions: number;
      worth_cad: number;
      cpm_distribution_index?: number;
      venue_type_id?: number;
      ssp_id?: number;
      publisher_id?: string;
      format?: {
        width: number;
        height: number;
        id?: number;
      };
      format_id?: number;
      is_video?: boolean;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/forecast/dooh/publisher_ssp',
      query: {
        'campaign_id': campaignId,
      },
    });
  }

  /**
   * Method that returns a dooh forecast from criterias with format and is_video context
   * @param campaignId
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiForecastDoohFormatIsVideo(
    campaignId?: number,
  ): CancelablePromise<{
    total_screens: number;
    total_impressions: number;
    total_spend: number;
    screens?: Array<{
      centroid_longitude: number;
      centroid_latitude: number;
      screen_ids?: Array<string>;
      screen_impressions?: Array<number>;
      screen_spends?: Array<number>;
      single_screen_data?: {
        screen_id?: string;
        screen_name?: string;
        publisher_id?: string;
        publisher_url?: string;
        country_id?: string;
        state_id?: string;
        city?: string;
        postal_code?: string;
        screen_address?: Array<string>;
        centroid_longitude?: number;
        centroid_latitude?: number;
        time_zone?: Array<string>;
        utcoffset?: number;
        impressions?: number;
        spend?: number;
        average_monthly_impressions?: number;
        average_monthly_spend?: number;
        ssp_id?: number;
        venue_type_ids?: Array<number>;
        screen_size?: number;
        audience_factor?: number;
        format?: Array<number>;
        allow_image?: boolean;
        allow_video?: boolean;
        last_update?: number;
      };
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    data?: Array<{
      date: string;
      screen_count: number;
      impressions: number;
      spend: number;
    }>;
    groups?: Array<{
      screen_count: number;
      impressions: number;
      worth_cad: number;
      cpm_distribution_index?: number;
      venue_type_id?: number;
      ssp_id?: number;
      publisher_id?: string;
      format?: {
        width: number;
        height: number;
        id?: number;
      };
      format_id?: number;
      is_video?: boolean;
    }>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/forecast/dooh/format_is_video',
      query: {
        'campaign_id': campaignId,
      },
    });
  }

}
